import { useEffect } from 'react'

const useChatAutoScroll = ({
  bottomRef,
  messages,
  typing,
}) => {
  useEffect(() => {
    bottomRef.current?.scrollIntoView({
      behavior: 'smooth',
    })
  }, [bottomRef, messages, typing])
}

export default useChatAutoScroll